import React, { useEffect, useState } from "react";
import { Star, ExternalLink } from "lucide-react";
import { reviewsApi } from "../api";

const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=Caregivers+Alliance+Homecare+Columbus+OH+reviews";

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "text-amber-400 fill-amber-400" : "text-slate-200 fill-slate-200"}`} />
    ))}
  </div>
);

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    reviewsApi.publicList().then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  if (!reviews.length) return null;

  return (
    <section className="section bg-white" data-testid="google-reviews-section">
      <div className="mx-auto max-w-6xl px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">Reviews</span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#0E2A33] mt-2">What families say about us</h2>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((r) => (
            <div key={r.id} data-testid="review-card" className="bg-[#F7FBFC] rounded-2xl border border-slate-100 p-6 flex flex-col">
              <Stars n={r.rating} />
              <p className="text-slate-600 text-sm mt-3 leading-relaxed flex-1">"{r.text}"</p>
              <div className="mt-4 flex items-center justify-between">
                <div>
                  <div className="font-semibold text-[#0E2A33] text-sm">{r.name}</div>
                  {r.date && <div className="text-xs text-slate-400">{r.date}</div>}
                </div>
                <span className="text-xs text-slate-400">{r.source} review</span>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="review-us-link"
            className="inline-flex items-center gap-2 text-[#0E5A72] font-semibold hover:underline"
          >
            Review us on Google <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
